import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganizationContext } from "@/hooks/useOrganizationContext";

export interface Branch {
  id: number;
  name: string;
  code: string | null;
  is_active: boolean | null;
}

export const useBranches = () => {
  const { organizationId } = useOrganizationContext();
  return useQuery({
    queryKey: ["branches", organizationId],
    queryFn: async () => {
      // @ts-ignore - branches table may not be in generated types yet
      let query = (supabase as any)
        .from("branches")
        .select("id, name, code, is_active")
        .eq("is_active", true)
        .order("id", { ascending: true });

      if (organizationId) {
        query = query.eq("organization_id", organizationId);
      }

      const { data, error } = await query;

      if (error) throw error;
      return (data || []) as Branch[];
    },
    staleTime: 5 * 60 * 1000,
  });
};
